import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useLanguage } from "inspector-common/lib/language";
import { TemplateHeader } from "inspector-common/lib/model";

interface TemplateSelectProps {
    templates: Array<TemplateHeader>
    templateId: string | null
    setTemplateId: Dispatch<SetStateAction<string | null>>
}

function TemplateSelect(props: TemplateSelectProps) {
    const language = useLanguage();
    const nullTemplate: TemplateHeader = {
        identifier: "NULL",
        name: language.document.nullTemplate
    }
    const templates = [...props.templates, nullTemplate]

    return <FormControl fullWidth>
        <InputLabel id="template-select">{language.document.template}</InputLabel>
        <Select
            labelId="template-select"
            value={props.templateId ?? "NULL"}
            label={language.document.template}
            onChange={(event: any) => {
                const value = event.target.value;
                if (value === "NULL") {
                    props.setTemplateId(null);
                } else {
                    props.setTemplateId(event.target.value);
                }
            }}
        >
            {(templates ?? []).map((template: TemplateHeader) => (
                <MenuItem key={template.identifier ?? "NO_TEMPLATE"} value={template.identifier}>
                    {template.name}
                </MenuItem>
            ))}

        </Select>
    </FormControl>
}

export default TemplateSelect;